module.exports = __webpack_public_path__ + "assets/marker.b70c033f.svg";